import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import type { CSSObject } from 'tss-react';

export const getInfoIcon = (
  title: string,
  onClick?: any,
  styles?: any,
  isStatic: boolean = true,
  staticTooltipStyles?: CSSObject,
  arrowStyles?: CSSObject,
) => {
  const useStyles = makeStyles()({
    tooltip: {
      backgroundColor: isStatic
        ? patientAccessTheme.palette.grey[700]
        : patientAccessTheme.palette.grey[900],
      padding: isStatic ? '6px' : '10px',
      fontSize: '13px',
      fontFamily: 'Inter',
      fontWeight: 400,
      lineHeight: '16px',
      color: patientAccessTheme.palette.status.white,
      maxWidth: 365,
    },
    arrow: {
      color: patientAccessTheme.palette.grey[900],
      marginLeft: '50px',
    },
    popper: {
      marginTop: '-8px',
      marginLeft: '-34px',
    },
    staticTooltip: {
      position: 'absolute',
      top: '-58px',
      width: '266px',
      left: '-180px',
      ...staticTooltipStyles,
    },
    arrowStyles: {
      borderLeft: `1px dashed ${patientAccessTheme.palette.grey[900]}`,
      transform: 'translateY(-50%)',
      zIndex: -1,
      width: '2px',
      height: '20px',
      position: 'absolute',
      top: '-4px',
      left: '59px',
      ...arrowStyles,
    },
  });

  const { classes } = useStyles();
  return isStatic ? (
    <Box style={{ display: 'inline-block', ...styles }} onClick={onClick}>
      <div className={`${classes.tooltip} ${classes.staticTooltip}`}>
        {title}
      </div>
      <div className={classes.arrowStyles}></div>
      <InfoOutlinedIcon
        style={{
          width: '17px',
          height: '17px',
          marginLeft: '4px',
          fill: patientAccessTheme.palette.status.icon,
        }}
      />
    </Box>
  ) : (
    <Tooltip
      arrow
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow,
        popper: classes.popper,
      }}
      title={title}
      placement="bottom-start"
    >
      <Box style={{ display: 'inline-block', ...styles }} onClick={onClick}>
        <InfoOutlinedIcon
          style={{
            width: '17px',
            height: '17px',
            marginLeft: '4px',
            fill: patientAccessTheme.palette.status.icon,
          }}
        />
      </Box>
    </Tooltip>
  );
};
